export default __webpack_public_path__ + "51cee6e644d2a117f8ff2865888e99bf.png";